import { axiosClient } from '@nx-frontend/shared/api';
import { FetchWorkspaceNotesTagsPayload, FetchWorkspaceNotesTagsResultItem } from '@nx-frontend/shared/types';

export const getWorkspaceNotesTags = async ({
  workspaceId,
}: FetchWorkspaceNotesTagsPayload): Promise<FetchWorkspaceNotesTagsResultItem[] | null> => {
  try {
    const { data } = await axiosClient.get<FetchWorkspaceNotesTagsResultItem[]>(
      `/v2/api/workspaces/${workspaceId}/notesTags`
    );
    return data;
  } catch (err) {
    return null;
  }
};
